export default "__VITE_ASSET__BCEMZZv___"